<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I would like to thank the many people who helped me in the preparation of this book, particularly those that allowed me to use their images thus putting faces to the many characters, maps and locations in this story.</p><br/>
<p>Specifically:</p>
<ul>
<li><p>Andy Thomas Fine Art for his outstanding painting, ‘Guerrillas’.</p></li>
<li><p>Emory Cantey, Jr. of the Cantey-Meyers Collection, so many rare photos.</p></li>
<li><p>Dick Tiggerington, The Civil War Muse, for his excellent coverage of the Lawrence Massacre.</p></li>
<li><p>Lisa Keys of the Kansas Historical Society.</p></li>
<li><p>Beth Beckett of the Jesse James Birthplace Museum.</p></li>
<li><p>Ron Pastore of Pastore Collection.</p></li>
<li><p>S. Buller of Alias Dictus—Outlaw Legends.</p></li>
<li><p>The Sherman Museum.</p></li>
<li><p>Erin Gray of the Jackson County Historical Society.</p></li>
<li><p>The Cass County Library.</p></li>
<li><p>Patrick Marquis.</p></li>
<li><p>The Miles-Peck Collection.</p></li>
<li><p>The St. Joseph Museums, Inc.</p></li>
<li><p>The Denver Public Library.</p></li>
</ul>
<br/><p style="text-indent:00em;">I also want to thank my beta readers who gave me wonderful feedback to correct or improve this work, Joe Brucella, Emory Cantey, Jr., Jeff Dudley and Barbara Zekala.</p>
<br/><p style="text-indent:00em;">This book would not have been possible without the support of my editor and publisher.</p>
<br/><p style="text-indent:00em;">Last but not least, my ‘partner in crime and life’, Sharon Davis. CAYB! WAYH!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?b42ec30a